import { Box, Button, CircularProgress, LinearProgress, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ItemList2 } from "./ItemList2";
import { MyListApi } from "../utils/restApi";
import { addNotification } from "../slices/notificationSlice";
import { TagChooser } from "./TagChooser";

export const Popular = () => {

    const user = useSelector(state => state.login.user);
    const dispatch = useDispatch();
    const [items, setItems] = useState([]);
    const [status, setStatus] = useState('init');
    const [tag, setTag] = useState(null);

    useEffect(() => {
        if (status === 'init') {
            setStatus('loading');
            MyListApi.popularItems(tag?.name, 0)
                .then(data => {
                    setStatus('loaded');
                    setItems(data.items);
                })
                .catch(error => {
                    setStatus('error');
                    dispatch(addNotification({
                        message: error.message,
                        type: 'error',
                    }));
                });
        }
    }, [tag, status, items]);

    const handleTagSelect = selectedTag => {
        setTag(selectedTag);
        setItems([]);
        setStatus('init');
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%', minHeight: '400px' }}>
            <Paper sx={{ p: '10px' }}>
                <TagChooser onSelect={handleTagSelect} />
            </Paper>
            {status === 'loading' ? <Box sx={{ display: 'flex', flexDirection: 'row', p: '50px', justifyContent: "center" }}><LinearProgress sx={{ width: '100%' }}/></Box>
                : <ItemList2 items={items} />
            }
        </Box>
    );
}